import { PropTypes } from 'prop-types';
import Utils from '@/common/utils/utils';
import TooltipThumb from '@/component/common/TooltipThumb';
import { getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';

function EmailImageAttachment({ item, detailTicket, setOpenPreviewImage, setOpenFileOption, setOpenOption }) {
    if (!item) return null;

    const imgLink = getLinkDownloadFileFromS3({ ...item, type: 1 }, detailTicket);

    return (
        <li className="justify-content-center">
            <div className="display-thumb">
                <div
                    className="class-relative cursor-default"
                    style={{ display: 'flex', gap: 5 }}
                >
                    <TooltipThumb
                        value={`${item.fileName}(${Utils.formatBytes(item.fileSize)})`}
                        className="titleDisplay"
                    >
                        <img
                            style={{
                                height: 50,
                                width: 70
                            }}
                            src={
                                Utils.isImageFile(item.fileName)
                                    ? imgLink
                                    : '/assets/image/others_file.png'
                            }
                            alt=""
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={() => {
                                setOpenPreviewImage(imgLink);
                            }}
                        />
                    </TooltipThumb>
                    <div
                        style={{
                            height: '100%',
                            backgroundColor: '#ecedef',
                            width: 20,
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        onClick={e => {
                            setOpenFileOption({
                                ...detailTicket.attachFiles.find(
                                    i => i.fileInfo.fileUrl === item?.fileUrl
                                )
                            });
                            setOpenOption(e.currentTarget);
                        }}
                    >
                        <img src="/assets/image/icon-more-panel.svg" alt="" />
                    </div>
                </div>
            </div>
        </li>
    );
}

EmailImageAttachment.propTypes = {
    item: PropTypes.any,
    detailTicket: PropTypes.any,
    setOpenPreviewImage: PropTypes.func,
    setOpenFileOption: PropTypes.func,
    setOpenOption: PropTypes.func
};

export default EmailImageAttachment;

